import styled from 'styled-components'
import Link from '../Link'
import LinkIconSvg from '../../img/link-icons/link-icon.svg'
import ExternalLink from '../ExternalLink'

export const LinkIcon = styled(LinkIconSvg)`
  color: ${(props) => props.theme.linkIconColor};
`

export const NavLink = styled.div`
  color: ${(props) => props.theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;

  margin-right: 60px;
  cursor: default;

  &:hover {
    color: ${(props) => props.theme.primary};
  }
`

export const Menu = styled.div`
  display: flex;
  align-items: center;
  margin-right: -48px;

  @media ${(props) =>
      props.theme.breakpoints && props.theme.breakpoints.tablet} {
    display: none;
  }
`

export const Options = styled.div`
  position: absolute;
  top: 10px;

  display: flex;
  flex-direction: column;

  width: ${(props) => props.width || '300px'};
  height: ${(props) => props.height || '300px'};
  border-radius: 12px;

  background-color: ${(props) => props.theme.optionsHeaderPrimary};
  color: #fff;
  margin: 40px;
  cursor: default;

  &:after {
    content: ' ';
    position: absolute;
    right: calc(50% - 10px);
    top: -10px;
    border-top: none;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 10px solid ${(props) => props.theme.optionsHeaderPrimary};
  }

  ${(props) =>
    props.break_new_line &&
    `
  @media screen and (max-width: 1200px) {
    width: calc(${props.width || '300px'} - 300px);
  }
  `}
`

export const HoverSection = styled.div`
  position: relative;
  top: 15px;
  padding-bottom: 25px;
  padding-left: 30px;
  width: 80px;
  margin-right: 50px;
  white-space: nowrap;
`

export const LinkGroup = styled.div`
  width: 100%;
  ${(props) =>
    props.first &&
    `
    padding-left: 32px;
  `}

  ${(props) =>
    props.last &&
    `
    padding-right: 32px;
  `}
`

export const OptionsGroup = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;

  &:nth-child(1) {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    ${(props) => props.fullBorder && 'border-radius: 12px;'}
  }
  &:nth-child(2) {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  background-color: ${(props) =>
    props.background === 'primary-darken'
      ? props.theme.optionsHeaderPrimaryDarken
      : props.theme.optionsHeaderPrimary};
`

export const HighlightSection = styled.div`
  width: 100%;
  color: ${(props) => props.theme.menuLabelColor};
  display: flex;

  &:hover {
    color: ${(props) => props.theme.menuLabelColor};
  }
`

export const HighlightSectionDescription = styled.div`
  margin-top: 25px;
  margin-left: 40px;
  width: 175%;

  span {
    display: block;
    margin-bottom: 10px;
    svg {
      margin-left: 5px;
    }
  }

  p {
    margin-top: 10px;
    font-size: 12px;
    font-weight: normal;
  }

  a {
    margin-top: 0px;
  }
`

export const HighlightSectionIcon = styled.div`
  margin-top: 38px;
  margin-left: 40px;
  width: 100%;
`

export const Sections = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

export const DetailedLink = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 36px;

  svg {
    width: 25px;
    height: 25px;
  }

  p {
    font-weight: normal;
    font-size: 12px;
    margin-top: 10px;
  }

  div {
    margin-left: 10px;
    white-space: normal;
  }
`

export const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 644px;

  > ${OptionsGroup}:nth-child(1) {
    height: 70%;
  }
  > ${OptionsGroup}:nth-child(2) {
    height: 100%;
    border-bottom-right-radius: 0px;
  }
`

export const MutableSection = styled.div`
  width: 300px;
  font-weight: normal;
  border-left: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 0px 12px 12px 0px;
  background-size: 330px 468px !important;
  background: ${(props) => `url(${props.background})`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const MutableTitle = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;

  span {
    font-size: 12px;
    line-height: 14px;
    color: ${(props) => props.theme.optionsDateAndButtonColor};
  }

  strong {
    margin-top: 12px;
    font-size: 24px;
    line-height: 28px;
  }
`

export const MutableDescription = styled.div`
  padding: 0px 32px;

  p {
    font-weight: 300;
    font-size: 11px;
    line-height: 15px;
    margin-bottom: 24px;
  }

  img {
    border-radius: 5px;
    margin-top: 10px;
  }
`

export const RedirectContainer = styled.div`
  div:nth-child(2) {
    padding: 0px;
  }

  margin-bottom: 32px;
  width: 100%;
  display: flex;
  justify-content: space-around;

  button {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    svg {
      width: 13px;
      height: 13px;
      path {
        fill: #fff;
        stroke: #fff;
      }
    }
    a {
      color: #fff;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      &:hover {
        color: #fff;
      }
    }
  }
`

export const NumberContainer = styled.div`
  width: 61px;
  height: 40px;

  color: #fff;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;

  background: rgba(0, 0, 0, 0.14);
  border-radius: 100px;

  display: flex;
  justify-content: center;
  align-items: center;
`

export const CustomLink = styled(Link)`
  font-size: 16px;
  display: block;
  color: ${(props) => props.theme.menuLabelColor};
  margin-top: ${(props) => (props.noMargin ? '0px' : '32px')};
  position: relative;
  width: 100%;

  svg {
    position: relative;
    margin-left: 5px;
    right: 0px;
  }
`
export const CustomExternalLink = styled(ExternalLink)`
  font-size: 16px;
  display: block;
  color: ${(props) => props.theme.menuLabelColor};
  margin-top: 32px;

  svg {
    position: relative;
    margin-left: 5px;
  }
`

export const HighlightSectionTextStyle = styled.p`
  white-space: break-spaces;
  width: 100%;
`
